module.exports = __webpack_public_path__ + "static-v-shop/1792141392954/img/landing-desktop-produs-1.c67dbbcb.png";